module.exports = __webpack_public_path__ + "img/search.8539fd89.svg";